import { useMemo } from "react";
import { Platform } from "react-native";

const getUserAgent = () => {
  if (typeof navigator === "undefined") {
    return "";
  }
  return navigator.userAgent || "";
};

const getDeviceMemory = () => {
  if (typeof navigator === "undefined") {
    return null;
  }
  return navigator.deviceMemory || null;
};

const getHardwareConcurrency = () => {
  if (typeof navigator === "undefined") {
    return null;
  }
  return navigator.hardwareConcurrency || null;
};

export function useDevicePerformance() {
  const isWeb = Platform.OS === "web";

  return useMemo(() => {
    if (!isWeb) {
      return {
        tier: "unknown",
        shouldUseLowPerformanceMode: false,
        shouldWarnLargeModels: false,
        reason: "",
        isSamsungA36Like: false,
      };
    }

    const ua = getUserAgent();
    const lowerUa = ua.toLowerCase();
    const memory = getDeviceMemory();
    const cores = getHardwareConcurrency();

    const isSamsungA36Like =
      /sm-a36|galaxy a36/.test(lowerUa) ||
      (/android/.test(lowerUa) && /adreno 710/.test(lowerUa));

    const lowMemory = memory !== null && memory <= 6;
    const lowCpu = cores !== null && cores <= 8;
    const androidPhone = /android/.test(lowerUa) && /mobile/.test(lowerUa);

    const shouldUseLowPerformanceMode =
      isSamsungA36Like || (androidPhone && (lowMemory || lowCpu));

    const tier = shouldUseLowPerformanceMode
      ? "low"
      : androidPhone
        ? "medium"
        : "high";

    const reason = shouldUseLowPerformanceMode
      ? "This phone can run large 3D models slowly. Low Performance Mode is recommended."
      : "";

    return {
      tier,
      shouldUseLowPerformanceMode,
      shouldWarnLargeModels: shouldUseLowPerformanceMode,
      reason,
      isSamsungA36Like,
    };
  }, [isWeb]);
}
